// Utils
// @ts-ignore
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Selectors
// HACK: disobeys folder structure rules
import {
    selectFirstDate
    // @ts-ignore
} from 'components/DatePagination/selectors';

const selectInitialValues = createDeepEqualSelector(
    [selectFirstDate],
    FirstDateState => ({
        weekDate: FirstDateState
    })
);

export { selectInitialValues };
